import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./elements/Widget/Pagination/Wrapper.js